var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-wd btn-fill btn-info",attrs:{"disabled":(_vm.loading || !_vm.eventSelected)},on:{"click":function($event){return _vm.runReport()}}},[_vm._v("\n  Gerar relatório simplificado de lâmpadas\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b24c958e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reports/LampsReportSimplified.vue
// module id = 0y/O
// module chunks = 10